export default "__VITE_ASSET__df64b2c6__"